import moduleGetters from "./getters.js";
import moduleMutations from "./mutations.js";
import moduleActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      userLoaded: null,
      userId: null,
      roleId: null,
      usersName: { firstName: null, lastName: null },
      userType: null,
      emailAddress: null,
      termsAccepted: { accepted: false, date: null },
      selectedCulture: null,
      sideMenuLock: false,
      showBanner: false,
      companyTitle: null,
      departments: [],
      managerId: null,
      startDate: null,
      profilePicture: null,
      // Mirrors the backend's sanitised projection: cv/documentation carry
      // metadata and a `stored` flag only — never an S3 key.
      jobPreferences: {
        // Explicit opt-in: is this user open to being considered for work?
        openToWork: false,
        // Months the user is NOT available. Stored as exceptions so an empty
        // list means "available" and cannot age into a false negative; the UI
        // still presents this to the user as availability.
        unavailability: [],
        skills: [],
        // Where the user is based. Same field names as a job's location so
        // the two can be compared, plus the geolocation the address lookup
        // returns.
        location: null,
        // Roles and the field within them the user is seeking, chosen from the
        // industry's own lists — the same vocabulary a job is posted in, so
        // the two can be matched.
        roles: [],
        specialisation: [],
        // What the user wants, in a job's own terms: contract/part-time/
        // full-time/casual and physical/hybrid/remote. Empty means no
        // preference rather than no answer.
        preferredJobType: [],
        preferredLocationType: [],
        workExperience: [],
        references: [],
        // The same shape the `jobPreferences` mutation builds, so a fresh
        // store and a loaded one agree.
        qualifications: [],
        industryExperience: [],
        rightsToWork: { type: null, expiryDate: null },
        salaryRange: { min: null, max: null },
        capabilityStatement: [],
        summary: null,
        objective: null,
        cv: { originalName: null, uploadedDate: null, stored: false },
        documentation: [],
      },
      company: {
        companyLoaded: null,
        companyUsersLoaded: null,
        companyId: null,
        name: null,
        countryCode: null,
        companyType: null,
        headOfficeAddress: null,
        companyDomain: null,
        allowAddUsers: null,
        primaryUser: null,
        businessNumber: null,
        registrationComplete: false,
        locations: [],
        departments: [],
        // Per-company feature toggles, e.g. enableRecruitment
        features: {},
        // Each industry entry is { industryId, documentation[] } — the
        // company's own selection from that industry's master lists. `skills`
        // was removed (2026-09-25): a job takes its skills from the industry's
        // own list, and a user's live on their profile.
        recruitment: {
          industries: [],
          capabilityStatementRequired: false,
          marketplaceEnabled: true,
        },
      },
      companies: [],
      users: [],
      theme: {
        themeEnabled: false,
        navTheme: "dark",
        logoIcon: null,
        logoIconInverse: null,
        logoFull: null,
        logoFullInverse: null,
        styles: {},
      },
    };
  },
  getters: moduleGetters,
  mutations: moduleMutations,
  actions: moduleActions,
};
